import * as React from 'react';
import { RouteComponentProps, Prompt } from 'react-router-dom';
import { Input } from '@progress/kendo-react-inputs';
import { fetchApi } from '../../services/api';
import * as moment from 'moment';
import { DatePicker } from '@progress/kendo-react-dateinputs';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import ClassroomTabs from './Tabs';
import LoadingButton from '../LoadingButton';
const DocumentTitle = require('react-document-title');

type ClassroomProps = RouteComponentProps<{
    classroomId: string
}>

type State = {
    isLoading: boolean;
    isDirty: boolean;
    Validation: boolean;

    classroom: ClassroomData | undefined;
}

type ClassroomData = {
    Facilities: Array<{ FacilityId: number, Name: string }>;
    FacilityID: number;
    ClassroomId: number;
    RoomDescription: string;
    StartDate: Date | null;
    EndDate: Date | null;
    RoomName: string;
    RoomId: string;
}

class Classroom extends React.Component<ClassroomProps, State> {
    constructor(props: ClassroomProps) {
        super(props);

        this.state = {
            isLoading: true,
            isDirty: false,
            Validation: false,
            classroom: undefined,
        }

        this.save = this.save.bind(this);
        this.delete = this.delete.bind(this);
    }

    public componentWillMount() {
        // This method runs when the component is first added to the page
        let classroomId = parseInt(this.props.match.params.classroomId) || 0;
        this.requestClassroom(classroomId);
    }

    public componentWillReceiveProps(nextProps: ClassroomProps) {
        // This method runs when incoming props (e.g., route params) change
        let classroomId = parseInt(nextProps.match.params.classroomId) || 0;

        if (this.state.classroom && this.state.classroom.ClassroomId != classroomId) {
            this.requestClassroom(classroomId);
        }
    }

    public render() {
        return <React.Fragment>
            {this.state.classroom && (this.state.classroom.ClassroomId != 0) && <ClassroomTabs classroomId={this.state.classroom.ClassroomId} history={this.props.history} classroom />}
            {this.state.classroom &&
                <div className="k-form">
                    <DocumentTitle title={this.state.classroom.RoomName || "New Classroom"} />
                    <Prompt when={this.state.isDirty} message="Unsaved changes will be lost, are you sure?" />
                    {this.state.isLoading && <div className="k-loading-image"></div>}
                    {this.state.classroom.Facilities.length > 0 &&
                        <DropDownList
                            textField='Name'
                            data={this.state.classroom.Facilities}
                            value={this.state.classroom.Facilities.find(x => x.FacilityId === (this.state.classroom as ClassroomData).FacilityID)}
                            onChange={(e) => {
                                this.updateClassroomState({ FacilityID: e.target.value.FacilityId });
                            }}
                            style={{ width: '100%', marginTop: '16px' }}
                        />}
                    {this.state.Validation && !this.state.classroom.FacilityID && <p className="error-msg">Facility is Required</p>}
                    <br />
                    <h5>Classroom Information</h5>
                    <label className="k-form-field">
                        <span>Room Name<span style={{ color: '#dc3545' }}>*</span></span>
                        <Input
                            type="text"
                            placeholder="Name"
                            value={this.state.classroom.RoomName}
                            onChange={(e) => this.updateClassroomState({ RoomName: e.target.value })}
                        />

                        {this.state.Validation && !this.state.classroom.RoomName && <p className="error-msg">Classroom Name is Required</p>}
                    </label>
                    <label className="k-form-field">
                        <span>Room ID<span style={{ color: '#dc3545' }}>*</span></span>
                        <Input
                            type="text"
                            placeholder="Room ID"
                            value={this.state.classroom.RoomId}
                            onChange={(e) => this.updateClassroomState({ RoomId: e.target.value })}
                        />
                        {this.state.Validation && !this.state.classroom.RoomId && <p className="error-msg">Classroom ID is Required</p>}
                    </label>
                    <label className="k-form-field">
                        <span>Room Description</span>
                        <Input
                            type="text"
                            placeholder="Room Description"
                            value={this.state.classroom.RoomDescription}
                            onChange={(e) => this.updateClassroomState({ RoomDescription: e.target.value })}
                        />
                    </label>
                    <div className="input-group">
                        <div className="input-group-prepend">
                            <span className="input-group-text">Start Date<div style={{ color: '#dc3545' }}>*</div></span>
                        </div>
                        <DatePicker
                            format="MM/dd/yyyy"
                            defaultValue={moment().toDate()}
                            name={`StartDate`}
                            formatPlaceholder="formatPattern"
                            value={this.state.classroom.StartDate}
                            onChange={(e) => this.updateClassroomState({ StartDate: e.value })}
                        />
                    </div>
                    <br />
                    <div className="input-group">
                        <div className="input-group-prepend">
                            <span className="input-group-text">End Date&nbsp;<div style={{ color: '#dc3545' }}>*</div></span>
                        </div>
                        <DatePicker
                            format="MM/dd/yyyy"
                            defaultValue={moment().toDate()}
                            name={`EndDate`}
                            formatPlaceholder="formatPattern"
                            value={this.state.classroom.EndDate}
                            onChange={(e) => this.updateClassroomState({ EndDate: e.value })}
                        />
                    </div>
                    {(this.state.Validation && !this.state.classroom.EndDate) ? <p className="error-msg">End Date is Required</p> : <br />}
                    <br />
                    <button className="btn btn-danger" onClick={this.delete}>Delete</button>
                    <LoadingButton 
                        onClick={this.save}
                        disabled={!this.state.isDirty}
                        isLoading={this.state.isLoading}
                        isLoadingText="Saving..."
                        className="btn btn-primary float-right"
                    >
                        {this.state.classroom.ClassroomId === 0 ? 'Create' : 'Save'}
                    </LoadingButton>
                </div>
            }
        </React.Fragment>;
    }

    private updateClassroomState(value: Object | ClassroomData) {
        const classroom = Object.assign({}, this.state.classroom, value);
        this.setState({ classroom, isDirty: true });
    }

    private requestClassroom(classroomId: number) {
        this.setState({ isLoading: true });
        fetchApi(`api/Classrooms/Get/${classroomId}`)
            .then((classroom: ClassroomData) => {
                classroom.StartDate = classroom.StartDate ? moment.utc(classroom.StartDate).toDate() : null;
                classroom.EndDate = classroom.EndDate ? moment.utc(classroom.EndDate).toDate() : null;
                
                // Default Facility
                const defaultFacilityId = parseInt(localStorage.getItem("FACILITY_ID") || "0");
                if (classroomId === 0 && defaultFacilityId > 0) {
                    classroom.FacilityID = defaultFacilityId;
                }
                this.setState({ isLoading: false, isDirty: false, classroom });
            });
    }

    private delete() {
        if (this.state.classroom && confirm(`Are you sure you want to delete this classroom?`)) {
            this.setState({ isLoading: true });
            fetchApi(`/api/Classrooms/Delete/${this.state.classroom.ClassroomId}`, {}, 'DELETE')
                .then(() => {
                    this.props.history.push("/classrooms");
                })
                .catch(() => {
                    this.setState({ isLoading: false });
                    alert("Unknown Error Occurred Deleting Classroom!");
                });
        }
    }

    private save() {
        this.setState({ Validation: true }, () => {
            if (this.state.classroom && document.getElementsByClassName("error-msg").length === 0) {
                this.setState({ isLoading: true });
                if (this.state.classroom.ClassroomId > 0) {
                    fetchApi(`api/Classrooms/Save/${this.state.classroom.ClassroomId}`, this.state.classroom, 'POST')
                        .then(() => {
                            this.setState({ isLoading: false, isDirty: false });
                        });
                } else {
                    fetchApi(`api/Classrooms/Create/`, this.state.classroom, 'POST')
                        .then((response: { ClassroomID: number }) => {
                            this.updateClassroomState({ ClassroomId: response.ClassroomID});
                            this.setState({ isLoading: false, isDirty: false });

                            this.props.history.push("/classrooms");
                        });
                }
            }
        });
    }
}

export default Classroom;
